import { ErrorMessage } from "../../enums/error-message";
export class PartnerIncentiveTracker {
    tracker;
    constructor(tracker) {
        this.tracker = tracker;
    }
    trackClick(trackingData, eventParams) {
        if (this.tracker === null) {
            throw new Error(ErrorMessage.DATA_LAYER_TRACKER_UNAVAILABLE);
        }
        this.tracker.trackECommerceClickEvent({
            eventParams,
            listEntityType: trackingData.listEntityType,
            listName: trackingData.listName,
            listPageType: trackingData.listPageType,
            item: trackingData.getTrackingContext()
        });
    }
    trackImpression(trackingData, eventParams) {
        this.tracker.trackECommerceImpressionEvent({
            eventParams,
            listEntityType: trackingData.listEntityType,
            listName: trackingData.listName ?? '',
            listPageType: trackingData.listPageType ?? '',
            item: trackingData.getTrackingContext()
        });
    }
}
